import { importExportApi } from "./index";

export interface ExportListParams {
  ids?: Array<string>;
  companyId?: string;
  type?: string;
  createdAtMin?: Date;
  createdAtMax?: Date;
  startedAtMin?: Date;
  startedAtMax?: Date;
  finishedAtMin?: Date;
  finishedAtMax?: Date;
  status?: "waiting" | "started" | "success" | "fail";
  offset?: number;
  limit?: number;
  sort?: "createdAt" | "startedAt" | "finishedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export const list = (params: ExportListParams, options?: any) => {
  return importExportApi.Export.listExports(
    params.ids,
    params.companyId,
    params.type,
    params.createdAtMin,
    params.createdAtMax,
    params.startedAtMin,
    params.startedAtMax,
    params.finishedAtMin,
    params.finishedAtMax,
    params.status,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    params.options
  );
};
